import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";

/** 1002:客服舱停用时客服页顶部横幅。 */
export function KefuHumanOnlyBanner() {
  const { t } = useTranslation("customer-service");
  return (
    <div
      role="status"
      data-testid="kefu-human-only-banner"
      className="flex items-start gap-2 rounded-lg border border-warning/40 bg-warning/10 px-3 py-2 text-sm text-foreground"
    >
      <Lock className="mt-0.5 h-4 w-4 shrink-0 text-warning" />
      <span>{t("humanOnly.banner")}</span>
    </div>
  );
}
